import { useState } from "react";

type FormFieldElement = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;

export const useForm = <T extends object>(initialForm: T) => {
    const [formState, setFormState] = useState(initialForm);

    const onInputChange = ({ target }: React.ChangeEvent<FormFieldElement>) => {
        const { name, value } = target;
        setFormState((current) => ({
            ...current,
            [name]: value,
        }));
    };

    const setField = <K extends keyof T>(name: K, value: T[K]) => {
        setFormState((current) => ({ ...current, [name]: value }));
    };

    const reset = () => setFormState(initialForm);

    return {
        formState,
        onInputChange,
        setField,
        reset,
    };
};